import { AlertCircle, Loader2 } from "lucide-react";

export function FilesListLoading({ label }: { label: string }) {
  return (
    <div className="flex items-center justify-center py-8">
      <Loader2 className="w-6 h-6 animate-spin text-primary-500" />
      <span className="ml-2">{label}</span>
    </div>
  );
}

export function FilesListError({ message }: { message: string }) {
  return (
    <div className="flex items-center justify-center py-8 text-red-500">
      <AlertCircle className="w-5 h-5 mr-2" />
      {message}
    </div>
  );
}
